import { render, staticRenderFns } from "./LogisticManagersList.vue?vue&type=template&id=00bdd1e0&scoped=true&"
import script from "./LogisticManagersList.vue?vue&type=script&lang=js&"
export * from "./LogisticManagersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bdd1e0",
  null
  
)

export default component.exports